    <template>
    <div
        class="relative z-30 max-w-screen-xl mx-auto flex justify-between items-stretch bg-white border-b space-x-4 md:hidden"
    >
        <a
            class="p-4 hover:bg-gray-200 text-gray-800 font-extrabold text-xl"
            :href="home"
        >
            🪵 Firewood Match
        </a>


        <button
            @click.prevent="toggle"
            type="button"
            class="p-2 flex items-center hover:bg-gray-200"
        >
            <icon v-if="show" type="x" class="w-5 h-5 text-gray-900" />
            <icon v-else type="hamburger" class="w-5 h-5 text-gray-900" />
        </button>

    </div>

    <transition
        enter-from-class="opacity-0"
        enter-active-class="transition ease-out duration-200"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-active-class="transition ease-in duration-300"
        leave-to-class="opacity-0"
    >
        <div
            v-if="show"
            @click.self="toggle"
            class="z-10 absolute inset-0 w-full h-full md:hidden bg-gray-600 bg-opacity-30"
        >
        </div>
    </transition>

    <transition
        enter-from-class="-translate-y-full"
        enter-active-class="transition ease-out duration-300 transform"
        enter-to-class="translate-y-0"
        leave-from-class="translate-y-0"
        leave-active-class="transition ease-in duration-200 transform"
        leave-to-class="-translate-y-full"
    >
        <div
            v-if="show"
            class="z-20 absolute w-full p-4 bg-white shadow-lg space-y-2 md:hidden"
        >
            <slot />
        </div>
    </transition>
</template>

<script>
import Icon from '@/components/shared/Icon'

export default {
    props: {
        home: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        close() {
            this.show = false
        },
        toggle() {
            this.show = !this.show
        },
        onEscape(e) {
            if(!this.show) return
            if(['Esc', 'Escape'].includes(e.key)) {
                 this.close()
             }
        }
    },
    watch: {
        show(value) {
            if(value) {
                document.body.classList.add('overflow-hidden')
                window.addEventListener('keyup', this.onEscape)
            } else {
                document.body.classList.remove('overflow-hidden')
                window.removeEventListener('keyup', this.onEscape)
            }
        }
    },
    components: {
        Icon
    }
}
</script>
